import { BaseControl, ControlPosition } from "./BaseControl.js";
import { Pano } from "../Pano.js";

export class ControlTrack extends BaseControl {
    private _trackProgress: HTMLElement;
    private _trackTime: HTMLElement;
    private _thumb: HTMLElement;
    private _isDragging: boolean = false;
    private _element: HTMLElement;

    constructor(pano: Pano) {
        super(pano);

        this._element = document.createElement("div");
        this._element.classList.add("control-track");
        this._element.innerHTML = `
            <div class="control-track-background"></div>
            <div class="control-track-progress"></div>
            <div class="control-track-time">
                <div class="control-track-thumb"></div>
            </div>
        `;
        this.pano.addControl(this._element, ControlPosition.SEEK);
        this._trackProgress = this._element.querySelector(".control-track-progress");
        this._trackTime = this._element.querySelector(".control-track-time");
        this._thumb = this._element.querySelector(".control-track-thumb");

        this.pano.video.addEventListener("progress", (e) => this.updateProgress());
        this.pano.video.addEventListener("timeupdate", (e) => this.updateTime());
        this.pano.onChangeVideo.add(() => this.reset());

        this.updateProgress();

        var px: number = 0;
        var drag = (pageX: number, pageY: number): void => {
            var bounds = this._element.getBoundingClientRect();
            var ratio = e5.Calc.clamp((pageX - bounds.left) / bounds.width, 0, 1);
            px = pageX;
            this._trackTime.style.width = (ratio * 100).toPrecision(6) + "%";
        };

        const actor = new e5.Actor(this._element);
        actor.onStart.add(() => {
            this._isDragging = true;
            this._thumb.classList.add("active");
            drag(actor.center.x, actor.center.y);
        });

        actor.onMove.add(() => {
            drag(actor.center.x, actor.center.y);
        });

        actor.onClear.add(() => {
            this._isDragging = false;
            this._thumb.classList.remove("active");
            this.seek(px);
        });
    }

    private reset(): void {
        this._trackTime.style.width = "0%";
        this._trackProgress.style.width = "0%";
        this.updateTime();

        this._element.classList.toggle("invisible", !this.pano.current);
    }

    private seek(pageX: number): void {
        var bounds = this._element.getBoundingClientRect();
        var ratio = (pageX - bounds.left) / bounds.width;
        this.pano.video.currentTime = ratio * this.pano.video.duration;
        this._trackTime.style.width = (ratio * 100).toPrecision(6) + "%";
    }

    private updateTime(): void {
        if (this._isDragging)
            return;
        var ratio = this.pano.video.currentTime / this.pano.video.duration;
        this._trackTime.style.width = (ratio * 100).toPrecision(6) + "%";
        this.updateProgress();
    }

    private updateProgress(): void {
        if (this.pano.video.buffered.length === 0) {
            this._trackProgress.style.width = "0";
            return;
        }
        var ratio = this.pano.video.buffered.end(0) / this.pano.video.duration;
        this._trackProgress.style.width = (ratio * 100).toPrecision(6) + "%";
    }
}